import React from 'react'
import { MorphReplace } from 'react-svg-morph'
import PropTypes from 'prop-types'

function Icon() {
  return (
    <svg
      t="1637286297960"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="3130"
      width="15"
      height="15"
    >
      <path
        d="M512 22.144c-271.008 0-490.656 219.296-490.656 489.856s219.68 489.856 490.656 489.856 490.656-219.296 490.656-489.856c0-270.56-219.68-489.856-490.656-489.856l0 0zM781.792 394.592l-315.872 322.688c-14.528 14.816-38.112 14.816-52.64 0l-171.104-174.784c-14.56-14.88-14.56-38.944 0-53.792s38.112-14.88 52.64 0l144.768 147.904 289.568-295.84c14.56-14.848 38.08-14.848 52.64 0s14.528 38.944-0.032 53.792l0 0z"
        fill="#8a8a8a"
        p-id="3131"
      />
    </svg>
  )
}
const InputSuffixOkIcon = (props) => {
  const { width, height, fill } = props
  return (
    <MorphReplace width={width} height={height} fill={fill}>
      <Icon />
    </MorphReplace>
  )
}

// 默认参数
InputSuffixOkIcon.defaultProps = {
  width: 12,
  height: 12,
  fill: '#fff',
}
// 参数类型
InputSuffixOkIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default InputSuffixOkIcon
